import { render } from "./DeleteModal.vue?vue&type=template&id=148c6de0"
const script = {}

import "./DeleteModal.vue?vue&type=style&index=0&id=148c6de0&lang=css"

import exportComponent from "/home/time/IdeaProjects/mektep-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__